import { render, staticRenderFns } from "./AdditionalFieldsDatePicker.vue?vue&type=template&id=1457b88e&scoped=true&lang=pug&"
import script from "./AdditionalFieldsDatePicker.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFieldsDatePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1457b88e",
  null
  
)

export default component.exports